module.exports = __webpack_public_path__ + "img/test_h.a4bf2522.png";